import { CLASSIFICATIONS_PREFIX } from '../../classifications/classification-filter.utils';
export const CUSTOMER_FILTER_KEYS = ['customersIdsByData', 'customerIdsByCode'];
export const ORDER_CONDITION_CLASSIFICATIONS_PREFIX = 'orderConditionClassificationsPrefix';
export const ORDER_CUSTOMER_CLASSIFICATIONS_PREFIX = 'customerClassificationPrefix';

export const ORDERS_FILTERS_KEYS = {
  ids: 'ids',
  code: 'code',
  baseCodes: 'baseCodes',
  orderStatus: 'status',
  integrationStatus: 'synchronized',
  suggestedCopies: 'suggestedCopyIds',
  orderVouchers: 'orderVoucherIds',
  archivedOrder: 'archivedOrder',
  orderSalesRepresentative: 'orderSalesRepresentativeIds',
  customerSalesRepresentative: 'customerSalesRepresentativeIds',
  orderSeller: 'sellerIds',
  orderCollections: 'ordersCollectionsIds',
  customerIds: 'customerIds',
  [CUSTOMER_FILTER_KEYS[0]]: CUSTOMER_FILTER_KEYS[0],
  [CUSTOMER_FILTER_KEYS[1]]: CUSTOMER_FILTER_KEYS[1],
  customerStatus: 'customerStatus',
  customerCityIds: 'customerCityIds',
  customerStates: 'customerStates',
  customerGroupIds: 'customerGroupIds',
  availability: 'availability',
  products: 'productIds',
  productColors: 'productColorIds',
  collections: 'collectionsIds',
  productCategory: 'productCategoryIds',
  deliveryWindows: 'deliveryWindowIds',
  startCreationDate: 'startCreatedAt',
  endCreationDate: 'endCreatedAt',
  startUpdatedDate: 'startUpdatedAt',
  endUpdatedDate: 'endUpdatedAt',
  minimumPrice: 'minimumPrice',
  maximumPrice: 'maximumPrice',
  [CLASSIFICATIONS_PREFIX]: 'classificationsIds',
  consultants: 'consultantIds',
  dateShortcutStep: 'shortcutStep',
  dateShortcut: 'dateShortcut',
  updatedDateShortcutStep: 'updatedDateShortcutStep',
  updatedDateShortcut: 'updatedDateShortcut',
  [ORDER_CUSTOMER_CLASSIFICATIONS_PREFIX]: 'customerClassificationIds',
  orderContractSignature: 'contractSignature',
  [ORDER_CONDITION_CLASSIFICATIONS_PREFIX]: 'conditionClassificationIds',
  orderGatewayPaymentStatus: 'orderGatewayPaymentStatus',
  brands: 'brandIds',
};

export const BRAND_ENVIRONMENT_ONLY_FILTER_KEYS: string[] = [
  ORDERS_FILTERS_KEYS.ids,
  ORDERS_FILTERS_KEYS.baseCodes,
  ORDERS_FILTERS_KEYS.suggestedCopies,
  ORDERS_FILTERS_KEYS.orderVouchers,
  ORDERS_FILTERS_KEYS.orderSeller,
  ORDERS_FILTERS_KEYS.orderCollections,
  ORDERS_FILTERS_KEYS.products,
  ORDERS_FILTERS_KEYS.productColors,
  ORDERS_FILTERS_KEYS.collections,
  ORDERS_FILTERS_KEYS.productCategory,
  ORDERS_FILTERS_KEYS.deliveryWindows,
  ORDERS_FILTERS_KEYS.consultants,
];

export const BRAND_ENVIRONMENT_ONLY_FILTER_PREFIXES: string[] = [
  CLASSIFICATIONS_PREFIX,
  ORDER_CONDITION_CLASSIFICATIONS_PREFIX,
];

export type OrderFilters = {
  [key: string]: any;
};

const formatCreatorsFilters = (prefixes: string[], values: Record<string, any> = {}) => {
  const valuesCopy = { ...values };
  const newValues = new Map<string, string[]>();
  for (let index = 0; index < prefixes.length; index++) {
    const prefix = prefixes[index];

    const ids = [];

    for (const [key, value] of Object.entries(values)) {
      if (key.startsWith(prefix)) {
        ids.push(value);
        delete valuesCopy[key];
      }
    }

    if (!!ids.length) {
      newValues.set(ORDERS_FILTERS_KEYS[prefix], ids.flat(2));
    }
  }

  return { ...valuesCopy, ...Object.fromEntries(newValues) };
};

export const formatOrderFilters = (values: Record<string, any> = {}): OrderFilters => {
  const newValues = formatCreatorsFilters(
    [
      CLASSIFICATIONS_PREFIX,
      ORDER_CONDITION_CLASSIFICATIONS_PREFIX,
      ORDER_CUSTOMER_CLASSIFICATIONS_PREFIX,
    ],
    values,
  );

  const cloneValues = { ...newValues };

  const customerIds: string[] = [];
  CUSTOMER_FILTER_KEYS.forEach((key) => {
    const ids = cloneValues[key];
    delete cloneValues[key];
    if (ids) {
      const idsInArray = Array.isArray(ids) ? ids : [ids];
      customerIds.push(...idsInArray);
    }
  });

  return {
    ...cloneValues,
    ...(customerIds.length > 0 && { [ORDERS_FILTERS_KEYS.customerIds]: customerIds }),
  };
};
